import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateSickLeaveMutation as useChUpdateSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/ch/services/__generated__/useChUpdateSickLeaveMutation.graphql"

const updateSickLeaveMutation = graphql`
  mutation useChUpdateSickLeaveMutation($input: Ch_updateSickLeaveInput!) {
    ch_updateSickLeave(input: $input) {
      ch_SickLeave {
        id
        ...chSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateSickLeaveMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateSickLeaveMutationType>(
    updateSickLeaveMutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateSickLeaveMutation }
